import { LatLng } from 'leaflet';

export default function deepCloneLatLngs(latLngs) {
  return latLngs.map(points => points.map((latLng) => {
    if (Array.isArray(latLng)) {
      return new LatLng(...latLng);
    } else {
      return new LatLng(latLng.lat, latLng.lng);
    }
  }));
}
